import SEO from "./SEO";

export default function SEOHome() {
  return (
    <SEO
      title="Watch Public Domain Movies Free | Paper Tiger Cinema"
      description="Explore 800+ classic public domain movies in HD. No ads, no subscriptions."
      url="https://papertigercinema.com/"
      image="https://cdn.papertigercinema.com/static/ptc_lgo.png"
    />
  );
}
